<template>
  <div>
    <v-card :loading="loading" flat>
      <div class="searchInput my-1">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="'Search ' + title"
          single-line
          hide-details
          outlined
          dense
          clearable
        ></v-text-field>
      </div>

      <v-data-table
        v-if="list"
        :headers="tableHeaders"
        :items="list"
        :search="search"
        dense
        :items-per-page="20"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
      >
        <!-- @click:row="doEdit" -->
        <template v-slot:[`item.${displayField}`]="{ item }">
          <!-- <v-btn icon @click="displayChange(item)"> -->
          <v-icon :color="displayIsTrue(item) ? 'green' : 'red'"
            >mdi-{{ displayIsTrue(item) ? "check" : "minus" }}</v-icon
          >
          <!-- </v-btn > -->
        </template>
        <template v-slot:[`item.${actionField}`]="{ item }">
          <v-btn text color="primary" @click="doEdit(item)">{{
            item[actionField]
          }}</v-btn>
        </template>
        <template v-slot:item.view="{ item }">
          <!-- <v-btn text color="primary" @click="doEdit(item)"></v-btn > -->
          <router-link
            :to="{ path: detailPath + item[idField] }"
            target="_blank"
          >
            <v-icon small class="ml-1" color="primary">mdi-open-in-new</v-icon>
          </router-link>
          <!-- {{ detailPath + item[idField] }} -->
        </template>

        <!-- prolly just used for ads .. -->
        <template v-slot:item.status="{ item }">
          <div
            :class="{
              'green--text': item.status == 'Active',
              'blue--text': item.status == 'Scheduled',
            }"
          >
            {{ item.status }}
          </div>
        </template>

        <template v-slot:item.description="{ item }">
          {{ item.description | truncate(80) }}
        </template>
        <template v-slot:item.updated="{ item }">
          <div class="noWrap">{{ item.updated }}</div>
        </template>
        <template v-slot:item.added="{ item }">
          <div class="noWrap">{{ item.added }}</div>
        </template>
      </v-data-table>
    </v-card>
    <!-- {{ list }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";

export default {
  name: "GenericAdminList",
  props: {
    api: null, // either call an api in this component
    data: null, // or send the data from the parent
    headers: {
      required: true,
    },
    actionField: { type: String, default: "name" },
    idField: { type: String, default: "id" }, // an identifier, "id" or "slug"
    displayField: { type: String, default: "display" }, // usually "hide", "display", "active", "published"
    displayFieldTrueVal: { type: Number, default: 1 }, // "active" or "display" want 1, "hide" want 0
    title: null,
    editPath: null, // the path to the page where this item can be edited. The value for the id field will be appended to this path
    detailPath: null,
    refresh: { type: Boolean, default: true },
    itemsKey: null, // if the API returns the list of items under a key
    sortBy: null, // a field to sort by
    sortDesc: null, // sort descending
  },
  data: function () {
    return {
      list: null,
      loading: false,
      search: null,
    };
  },
  methods: {
    getList() {
      // console.log("getList");
      if (!this.api) return;
      this.loading = true;
      ApiServices[this.api]("admin=1")
        .then((response) => {
          this.list = this.itemsKey
            ? response.data[this.itemsKey]
            : response.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
          this.$emit("loaded", true);
        });
    },
    displayIsTrue(item) {
      let val = parseInt(item[this.displayField]);
      //   console.log(item, val, this.displayFieldTrueVal);
      return val == this.displayFieldTrueVal;
    },
    // displayChange(item) {
    //   let id = item[this.idField];
    //   let val = !parseInt(item[this.displayField]);
    //   this.$emit("displayChange", { id: id, val: val });
    // },
    doEdit(item) {
      let identifier = item[this.idField];
      this.$router
        .push({ path: `${this.editPath}/${identifier}` })
        .catch(() => {});
      // this.$emit("doEdit", id);
    },
  },
  computed: {
    tableHeaders: function () {
      let h = this.headers;
      if (this.detailPath) h.push({ value: "view", text: "View" });
      return h;
    },
  },
  watch: {
    refresh(val) {
      if (val) this.getList();
    },
    data(val) {
      if (val) this.list = val;
    },
  },
  mounted() {
    if (this.api) this.getList();
    if (this.data) this.list = this.data;
  },
  metaInfo() {
    return {
      title: "EyeDock Admin - " + this.title,
    };
  },
};
</script>

<style scoped>
.searchInput {
  max-width: 300px;
}
.noWrap {
  white-space: nowrap;
}
</style>
